export default "__VITE_ASSET__99c04e3e__"